import React from "react";

const TermsOfUse = () => {
  return (
    <section className="w-full bg-primary text-white relative">
      <div className="max-w-6xl mx-auto px-4 py-16 pt-32 md:pt-40 flex flex-col md:flex-row items-center">
        <h1 className="text-brandAccent text-4xl md:text-5xl font-extrabold mb-4">
          Terms of Use
        </h1>
      </div>
      <div className="px-4 md:px-12 py-32 rounded-tl-3xl bg-white text-primary">
        {/* Intro */}
        <p className="mb-5 text-base md:text-lg underline">
          PLEASE READ THE TERMS OF THIS POLICY CAREFULLY BEFORE SUBSCRIBING FOR
          OR USING the Zorqk Website
        </p>
        <p className="ml-10">
          1. Important information about Cayson Global and the Site
        </p>
        <p className="ml-10">2. THE ZORQK Website</p>
        <p className="mb-5 text-base md:text-lg mt-5">
          This acceptable use policy (“Policy”) relates to the car advertising
          website known as “Zorqk.com” and any associated websites and the
          web-based mobile application (“Site”).
        </p>
        <p className="mb-5 text-base md:text-lg">
          More details regarding the Site can be found here:{" "}
          <a href="https://zorqk.com/" className="text-blue-500 underline">
            https://zorqk.com/
          </a>
        </p>
        <p className="mb-5 text-base md:text-lg">
          The Site includes a web-based application of the same name.
        </p>

        {/* Who provides */}
        <h2 className="font-bold text-lg md:text-2xl my-8">
          WHO PROVIDES AND OPERATES THE SITE?
        </h2>
        <p className="mb-5 text-base md:text-lg">
          The Site is operated by Cayson Global Limited registered in the United
          Arab Emirates with company number IC20152132 and with registered
          address at Office 904, JCB 4, Cluster N, Jumeriah Lake Towers, PO Box
          No. 336618 (referred to as "Cayson Global” "we", "us" or "our" in this
          Policy).
        </p>

        {/* Who uses */}
        <h2 className="font-bold text-lg md:text-2xl my-8">
          WHO USES THE SITE?
        </h2>
        <p className="mb-5 text-base md:text-lg">
          Cayson Global makes the Site available to individuals, such as
          students, who download and subscribe for access to the Site (“User”)
          subject to the Users agreement to the Site’s terms and conditions
          (“Terms and Conditions”).
        </p>

        {/* Acceptable Use */}

        <ol className="list-decimal list-inside pl-5 space-y-2">
          <li>Acceptable use restrictions relating to THE SITE</li>
          <li>
            Use of the Site is subject to compliance with this Policy which
            contains:
          </li>
          <li>
            <span className="underline">Licensing Restrictions</span>
          </li>
          <li>
            <span className="underline">Fair Usage Controls</span>
          </li>
          <li>
            <span className="underline">Prohibited Uses</span>
          </li>
          <li>
            <span className="underline">Content Standards</span>
          </li>
          <li>
            This Policy should be read alongside the Terms and Conditions of
            which they form a part.
          </li>
          <li>Licensing Restrictions</li>
          {/* nested list starts here */}
          <ol className="list-decimal list-inside pl-6 mt-2 space-y-1">
            <li>
              <span className="font-bold">No modification.</span> You shall not
              at any time modify, reverse-engineer, disassemble or decompile the
              Site, or attempt to do so.
            </li>
            <li>
              <span className="font-bold">No redistribution.</span> You shall
              not, at any time redistribute, or resell, or otherwise transfer to
              any third party the Site or its features.
            </li>
            <li>
              <span className="font-bold">Prohibited activities.</span>
              You shall not undertake or attempt to undertake any form of
              hacking, spamming, unauthorised data manipulation, extraction,
              fraudulent activity, leveraging, or any other form of illegal
              activity involving or in connection with the Site.
            </li>
            <li>
              <span className="font-bold">
                No sharing of authentication credentials.
              </span>{" "}
              You are not permitted to share usernames, passwords, MFA
              credentials or other authentication details with unauthorised
              individuals or organisations. This extends to moving licences from
              one named user to another.
            </li>
            <li>
              <span className="font-bold">
                No unauthorised third-party access.
              </span>{" "}
              You shall take all reasonable steps to prevent and/or otherwise
              restrict third parties from accessing the Site without proper
              licensing or Cayson Global’s explicit written permission.
            </li>
            <li>
              <span className="font-bold">
                No circumventing of access controls.
              </span>{" "}
              You are prohibited from bypassing any access restrictions, such as
              using VPNs, proxies, or shared accounts to allow unlicensed users
              to access restricted content or services.
            </li>
            <li>
              <span className="font-bold">
                No use of bots or automated tools.
              </span>{" "}
              You shall not set up any automated systems (including but not
              limited to bots, scripts, or APIs) to allow unauthorised
              third-party access to the Site or data held within.
            </li>
            <li>
              <span className="font-bold">Minimum system requirements.</span>{" "}
              You must use hardware and software that are supported and
              up-to-date in order to access the Site.
            </li>
            <li>
              <span className="font-bold">No use of end-of-life software.</span>{" "}
              You should not access the Site using software or hardware that is
              no longer supported by Cayson Global (e.g. outdated versions of
              iOS or Android).
            </li>
            <li>
              <span className="font-bold">
                No false or misleading information.
              </span>{" "}
              You must provide accurate and truthful information during
              registration and general use of the Site, and are prohibited from
              creating fake accounts, impersonation, or misrepresentation of
              identity.
            </li>
            <li>
              <span className="font-bold">No payment fraud.</span> You shall not
              use stolen credit cards, fraudulent payment methods, and/or engage
              in any chargeback fraud or payment fraud of any kind.
            </li>
            <li>
              <span className="font-bold">
                No money laundering or financial fraud.
              </span>{" "}
              You shall under no circumstances use the Site to transfer money
              illegally, engage in Ponzi schemes, and/or conduct fraudulent
              financial activities.
            </li>
            <li>
              <span className="font-bold">
                No Phishing, Scams, or Deceptive Practices.
              </span>{" "}
              You shall not deceive, trick, or defraud other users (or attempt
              to) through phishing schemes, fake transactions or identity theft.
            </li>
            <li>
              <span className="font-bold">No automated or bot fraud.</span> You
              shall not use any bots, scripts, or automated tools or similar, to
              manipulate the Site, scrape data, or create fake interactions.
            </li>
            <li>Fair Usage Controls</li>
            <ol className="list-decimal list-inside pl-6 mt-2 space-y-1">
              <li>
                <span className="font-bold">Fair use of customer support.</span> Any support requests you make
                should be limited to reasonable inquiries related to service
                issues. Abuse of any Cayson Global support channels may result
                in account restrictions being applied.
              </li>
              <li>
                <span className="font-bold">Storage Limits.</span> Any excessive storage through use of the Cayson
                Global file repository features may result in service
                restrictions.
              </li>
              <li>
                <span className="font-bold">Prohibited Content Distribution.</span> Disclosing, disseminating or
                otherwise sharing copyrighted, false or illegal content through
                the Site is strictly prohibited.
              </li>
              <li>
                <span className="font-bold">Geographic Restrictions.</span> The Site shall not under any
                circumstances be accessed in embargoed countries as per
                applicable law and any regulatory guidelines issued from time to
                time.
              </li>
              <li>
                <span className="font-bold">Restrictions on third-party integrations.</span> You shall not use any
                unauthorised third-party plugins or integrations that compromise
                system integrity or performance of the Site.
              </li>
            </ol>
            <li>Prohibited Uses</li>
            <ol className="list-decimal list-inside pl-6 mt-2 space-y-1">
              <li>You may not use the Site:</li>
              <ol className="list-decimal list-inside pl-6 mt-2 space-y-1">
                <li>If you are under 18.</li>
                <li>
                  In any way that breaches any applicable local, national or
                  international law or regulation.
                </li>
                <li>
                  In any way that is unlawful or fraudulent or has any unlawful
                  or fraudulent purpose or effect.
                </li>
                <li>
                  For the purpose of harming or attempting to harm minors in any
                  way.
                </li>
                <li>
                  To bully, insult, intimidate, humiliate or harass any person.
                </li>
                <li>To defame any person or company.</li>
                <li>
                  To publish a malicious falsehood about any person or company.
                </li>
              </ol>
            </ol>
          </ol>
          <li>
            To transmit, or procure the sending of, any unsolicited or
            unauthorised advertising or promotional material or any other form
            of similar solicitation (spam).
          </li>
          <li>
            To knowingly transmit any data, send or upload any material that
            contains viruses, Trojan horses, worms, time-bombs, keystroke
            loggers, spyware, adware or any other harmful programs or similar
            computer code designed to adversely affect the operation of any
            computer software or hardware.
          </li>
          <li>In any way that involves child sexual exploitation or abuse.</li>
          <li>To upload terrorist content.</li>
          <li>
            To infringe any copyright, database right or trade mark of any other
            intellectual property right of any person or company.
          </li>
          <ol className="list-decimal list-inside pl-6 mt-2 space-y-1">
            <li>
              You also agree not to access without authority, interfere with,
              damage or disrupt:
            </li>
            <ol className="list-decimal list-inside pl-6 mt-2 space-y-1">
              <li>any part of the Site;</li>
              <li>any equipment or network on which our site is stored;</li>
              <li>any software used in the provision of our site; or</li>
              <li>
                any equipment or network or software owned or used by any third
                party.
              </li>
            </ol>
          </ol>
          <li>Content Standards</li>
          <ol className="list-decimal list-inside pl-6 mt-2 space-y-1">
            <li>
              These content standards apply to any and all material which you
              contribute to our Site (“<span className="font-bold">Contribution</span>”).
            </li>
            <li>
              The Content Standards must be complied with in spirit as well as
              to the letter. The standards apply to each part of any
              Contribution as well as to its whole.
            </li>
            <li>
              If your Content is reported for breaching these terms, Cayson
              Global will review the Content and determine, in its discretion,
              whether a Contribution breaches the Content Standards.
            </li>
            <li>A Contribution:</li>
            <ol className="list-decimal list-inside pl-6 mt-2 space-y-1">
              <li>Must be accurate (where it states facts).</li>
              <li>Only contain opinions that are genuinely held.</li>
              <li>
                Must comply with the law Sitelicable in any country from which
                it is posted and to which the website is targeted.
              </li>
              <li>A Contribution must not:</li>
              <ol className="list-decimal list-inside pl-6 mt-2 space-y-1">
                <li>Be defamatory of any person or company.</li>
                <li>Be a malicious falsehood about any person or company.</li>
                <li>Be obscene, offensive, hateful or inflammatory.</li>
                <li>Bully, insult, intimidate, humiliate or harass.</li>
                <li>
                  Encourage, promote or provide instructions for deliberate
                  self-harm.
                </li>
                <li>Encourage, promote or provide instructions for suicide.</li>
                <li>
                  Encourage, promote or provide instructions for an eating
                  disorder or behaviours associated with an eating disorder.
                </li>
                <li>Promote sexually explicit material.</li>
                <li>Include child sexual abuse material.</li>
                <li>Incite violence or hatred against particular groups.</li>
                <li>
                  Promote discrimination based on race, sex, religion,
                  nationality, disability, sexual orientation or age.
                </li>
                <li>
                  Include content that would be considered a criminal offence
                  under laws relating to terrorism, child sexual abuse material,
                  racism or xenophobia.
                </li>
                <li>
                  Infringe any copyright, database right or trade mark of any
                  other intellectual property rights of any person or company.
                </li>
                <li>
                  Include video content that has been or would be likely to be
                  given an R18 certificate by the British Board of Film
                  Classification (BBFC).
                </li>
                <li>
                  Include video content not suitable for BBFC classification.
                </li>
                <li>
                  Include material that might impair the physical, mental or
                  moral development of persons under the age of 18.
                </li>
                <li>Be likely to deceive any person.</li>
                <li>
                  Breach any legal duty owed to a third party, such as a
                  contractual duty or a duty of confidence.
                </li>
                <li>
                  Contain illegal content or promote any illegal content or
                  activity.
                </li>
                <li>Be in contempt of court.</li>
                <li>
                  Be threatening, abuse or invade another's privacy, or cause
                  annoyance, inconvenience or needless anxiety.
                </li>
                <li>
                  Be likely to harass, upset, embarrass, alarm or annoy any
                  other person.
                </li>
                <li>
                  Impersonate any person or misrepresent your identity or
                  affiliation with any person.
                </li>
                <li>
                  Give the impression that the Contribution emanates from Cayson
                  Global or our partners, if this is not the case.
                </li>
                <li>
                  Advocate, promote, incite any party to commit, or assist any
                  unlawful or criminal act such as (by way of example only)
                  copyright infringement or computer misuse.
                </li>
                <li>
                  Contain a statement which you know or believe, or have
                  reasonable grounds for believing, that members of the public
                  to whom the statement is, or is to be, published are likely to
                  understand as a direct or indirect encouragement or other
                  inducement to the commission, preparation or instigation of
                  acts of terrorism.
                </li>
                <li>
                  Contain any advertising or promote any services or web links
                  to other sites.
                </li>
              </ol>
              <li>Breach of this policy</li>
              <ol className="list-decimal list-inside pl-6 mt-2 space-y-1">
                <li>
                  When we consider that a breach of this Policy has occurred, we
                  may take such action as we deem appropriate.
                </li>
                <li>
                  Failure to comply with this acceptable use policy constitutes
                  a material breach of the Terms and Conditions and we may do
                  any of the following:
                </li>
                <ol className="list-decimal list-inside pl-6 mt-2 space-y-1">
                  <li>
                    Terminate our agreement with you immediately as a result.
                  </li>
                  <li>
                    Immediate, temporary or permanent withdrawal of your right
                    to use the Site.
                  </li>
                  <li>
                    Immediate, temporary or permanent removal of any
                    Contribution uploaded by you to the Site.
                  </li>
                  <li>Issue a warning to you.</li>
                  <li>
                    Commence legal proceedings against you for reimbursement of
                    any and all costs in full (including, but not limited to,
                    reasonable administrative and legal costs) resulting from
                    the breach.
                  </li>
                  <li>Take further legal action against you.</li>
                  <li>
                    Disclosure of such information to law enforcement
                    authorities as we reasonably feel is necessary or as
                    required by law.
                  </li>
                </ol>
                <li>
                  We exclude our liability for all action we may take in
                  response to breaches of this Policy.
                </li>
                <li>
                  The actions we may take are not limited to those described
                  above, and we may take any other action we reasonably deem
                  appropriate.
                </li>
              </ol>
            </ol>
          </ol>
        </ol>
      </div>
    </section>
  );
};

export default TermsOfUse;

// import React from "react";

// const TermsOfUse = () => {
//   return (
//     <section className="w-full bg-primary text-white relative">
//       <div className="max-w-6xl mx-auto px-4 py-16 pt-32 md:pt-40 flex flex-col md:flex-row items-center">
//         <h1 className="text-brandAccent text-4xl md:text-5xl font-extrabold mb-4">
//           Terms of Use
//         </h1>
//       </div>
//       <div className="px-4 md:px-12 py-32 rounded-tl-3xl bg-white text-primary">
//         <p className="mb-5 text-base md:text-lg underline">
//           PLEASE READ THE TERMS OF THIS POLICY CAREFULLY BEFORE SUBSCRIBING FOR
//           OR USING the Zorqk Website
//         </p>

//         <p className="ml-10">
//           1. Important information about Cayson Global and the Site
//         </p>
//         <p className="ml-10">2. THE ZORQK Website</p>

//         <p className="mb-5 text-base md:text-lg mt-5">
//           This acceptable use policy (“Policy”) relates to the car advertising
//           website known as “Zorqk.com” and any associated websites and the web
//           based mobile application (“Site”).
//         </p>

//         <p className="mb-5 text-base md:text-lg mt-5">
//           More details regarding the Site can be found here: https://zorqk.com/
//         </p>
//         <p className="mb-5 text-base md:text-lg mt-5">
//           The Site includes a web-based application of the same name.
//         </p>

//         <h1 className="font-bold text-lg md:text-2xl my-8">
//           WHO PROVIDES AND OPERATES THE SITE?
//         </h1>

//         <p className="mb-5 text-base md:text-lg">
//           The Site is operated by Cayson Global Limited registered in the United
//           Arab Emirates with company number IC20152132 and with registered
//           address at Office 904, JCB 4, Cluster N, Jumeriah Lake Towers, PO Box
//           No. 336618 (referred to as "Cayson Global” "we", "us" or "our" in this
//           Policy).
//         </p>

//         <h1 className="font-bold text-lg md:text-2xl my-8">
//           WHO USES THE SITE?
//         </h1>

//         <p className="mb-5 text-base md:text-lg">
//           Cayson Global makes the Site available to individuals, such as
//           students, who download and subscribe for access to the Site (“User”)
//           subject to the Users agreement to the Site’s terms and conditions
//           (“Terms and Conditions”).
//         </p>

//         <ol>
//           <li></li>
//         </ol>

//         {/* <p className="mb-5 text-base md:text-lg">
//           <span className="font-bold">Effective Date:</span> 07 July 2024{" "}
//           <span className="font-bold pl-3">Last Updated:</span> 07 July 2024
//         </p>

//         <p className="mb-5 text-base md:text-lg">
//           Welcome to Zorqk.com (“Zorqk”, “we”, “us”, or “our”). These Terms of
//           Use (“Terms”) govern your access to and use of our website and
//           services that facilitate the browsing and purchasing of used vehicles
//           listed by our partner companies.
//         </p>

//         <h1 className="font-bold text-lg md:text-2xl my-8">
//           1. Acceptance of Terms
//         </h1>
//         <p className="mb-5 text-base md:text-lg">
//           By accessing or using Zorqk.com, you agree to be bound by these Terms
//           and our [Privacy Policy]. If you do not agree, please do not use our
//           services.
//         </p>

//         <h1 className="font-bold text-lg md:text-2xl my-8">2. Platform Role</h1>
//         <ul className="list-disc pl-5 space-y-2 mb-5 text-base md:text-lg">
//           <li>
//             Zorqk provides a digital platform for users to browse and purchase
//             used vehicles.
//           </li>
//           <li>
//             All vehicle listings are managed and maintained by our partner
//             company (“Listing Provider”).
//           </li>
//           <li>
//             Zorqk does not own, inspect, or verify the vehicles listed on the
//             platform.
//           </li>
//         </ul>

//         <h1 className="font-bold text-lg md:text-2xl my-8">
//           3. User Eligibility
//         </h1>
//         <p className="mb-5 text-base md:text-lg">
//           You must be at least 18 years old and legally capable of entering into
//           binding agreements to use our services.
//         </p>

//         <h1 className="font-bold text-lg md:text-2xl my-8">4. User Accounts</h1>
//         <ul className="list-disc pl-5 space-y-2 mb-5 text-base md:text-lg">
//           <li>Certain features may require account registration.</li>
//           <li>
//             You are responsible for maintaining the confidentiality of your
//             login credentials.
//           </li>
//           <li>You agree to provide accurate and up-to-date information.</li>
//         </ul>

//         <h1 className="font-bold text-lg md:text-2xl my-8">
//           5. Listings and Transactions
//         </h1>
//         <ul className="list-disc pl-5 space-y-2 mb-5 text-base md:text-lg">
//           <li>
//             All vehicle information, pricing, and availability are provided by
//             the Listing Provider.
//           </li>
//           <li>
//             Zorqk is not a party to any transaction between buyers and the
//             Listing Provider.
//           </li>
//           <li>
//             Users should verify all details directly with the Listing Provider
//             before making a purchase.
//           </li>
//         </ul>

//         <h1 className="font-bold text-lg md:text-2xl my-8">
//           6. Prohibited Conduct{" "}
//         </h1>
//         <p className="mb-5 text-base md:text-lg">You agree not to:</p>
//         <ul className="list-disc pl-5 space-y-2 mb-5 text-base md:text-lg">
//           <li>Use the platform for unlawful or fraudulent purposes.</li>
//           <li>Interfere with the operation or security of the website.</li>
//           <li>
//             Post or transmit any harmful, misleading, or unauthorized content.
//           </li>
//         </ul>

//         <h1 className="font-bold text-lg md:text-2xl my-8">
//           7. Fees and Payments
//         </h1>
//         <ul className="list-disc pl-5 space-y-2 mb-5 text-base md:text-lg">
//           <li>
//             Zorqk may charge fees for certain services, which will be clearly
//             disclosed.
//           </li>
//           <li>
//             Payments for vehicles are handled directly between users and the
//             Listing Provider.
//           </li>
//         </ul>

//         <h1 className="font-bold text-lg md:text-2xl my-8">8. Disclaimers</h1>
//         <ul className="list-disc pl-5 space-y-2 mb-5 text-base md:text-lg">
//           <li>
//             Zorqk makes no warranties regarding the accuracy, condition, or
//             legality of any vehicle listed.
//           </li>
//           <li>
//             We do not guarantee the performance or conduct of any user or
//             Listing Provider.
//           </li>
//         </ul>

//         <h1 className="font-bold text-lg md:text-2xl my-8">
//           9. Limitation of Liability
//         </h1>
//         <p className="mb-5 text-base md:text-lg">
//           To the fullest extent permitted by law, Zorqk shall not be liable for
//           any indirect, incidental, or consequential damages arising from your
//           use of the platform.
//         </p>

//         <h1 className="font-bold text-lg md:text-2xl my-8">10. Termination</h1>
//         <p className="mb-5 text-base md:text-lg">
//           We reserve the right to suspend or terminate access to the platform
//           for any user who violates these Terms.
//         </p>

//         <h1 className="font-bold text-lg md:text-2xl my-8">
//           11. Changes to Terms
//         </h1>
//         <p className="mb-5 text-base md:text-lg">
//           We may update these Terms from time to time. Continued use of the
//           platform after changes constitutes acceptance of the revised Terms.
//         </p>

//         <h1 className="font-bold text-lg md:text-2xl my-8">12. Contact Us</h1>
//         <p className="mb-5 text-base md:text-lg">
//           For questions or concerns, please contact us at:{" "}
//           <a
//             href="mailto:support@zorqk.com"
//             className="text-blue-400 font-bold"
//           >
//             support@zorqk.com
//           </a>
//         </p> */}
//       </div>
//     </section>
//   );
// };

// export default TermsOfUse;
